module.exports = __webpack_public_path__ + "static/media/Rex Orange County - Loving is Easy (feat. Benny Sings) [Official Video].759a650a.mp3";